<app-template-map
  [disabled]="disabled"
  [mode]="mode"
  [value]="value"
  [control]="control"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [options]="options"
  [label]="label"
/>
